import type { EntryPointRouteParams } from '@jira/platform__entry-points-plugin-types/src/types.tsx';
import { JSResourceForInteraction } from '@atlassian/react-async';
import { createEntryPoint } from '@atlassian/react-entrypoint';
import PlaybookLogsQuery$parameters from '@atlassian/jira-playbooks-list-screen/src/ui/playbook-logs/__generated__/PlaybookLogsQuery$parameters';

const playbookLogsViewEntryPoint = createEntryPoint({
	root: JSResourceForInteraction(
		() => import(/* webpackChunkName: "async-spa-apps-playbooks-logs" */ './src'),
	),
	getPreloadProps: ({ context, tenantContext }: EntryPointRouteParams) => {
		const { projectKey } = context.match.params;
		const { name = '' } = context.query;

		if (!projectKey) {
			throw new Error('projectKey is required');
		}

		return {
			queries: {
				PlaybookLogsQuery: {
					parameters: PlaybookLogsQuery$parameters,
					variables: {
						cloudId: tenantContext.cloudId,
						projectKey,
						first: PLAYBOOK_LOGS_FIRST_COUNT,
						filter: name ? { name } : null,
					},
				},
			},
			extraProps: {
				projectKey: context.match.params.projectKey,
			},
		};
	},
});
const PLAYBOOK_LOGS_FIRST_COUNT = 20;

export default playbookLogsViewEntryPoint;
